import * as Yup from "yup";

export const emailValidation = Yup.string()
  .trim()
  .test("optional-email", "Invalid email format", (value) => {
    const v = String(value ?? "").trim();
    if (!v) return true;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  });

export const passwordValidation = Yup.string()
  .required("Password is required")
  .min(8, "Password must be at least 8 characters")
  .matches(/^\S*$/, "Password must not contain spaces")
  .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
  .matches(/[a-z]/, "Password must contain at least one lowercase letter")
  .matches(/\d/, "Password must contain at least one number")
  .matches(
    /[@$!%*?&#]/,
    "Password must contain at least one special character"
  );

export const confirmPasswordValidation = (passwordField: string = "password") => 
  Yup.string()
    .required("Confirm password is required")
    .matches(/^\S*$/, "Confirm password must not contain spaces")
    .oneOf([Yup.ref(passwordField)], "Passwords must match");

export const phoneValidation = Yup.string()
  .required("Phone number is required")
  .matches(
    /^[6-9]\d{9}$/,
    "Enter valid 10-digit number starting with 6-9"
  );

export const nameValidation = Yup.string()
  .required("Name is required")
  .min(2, "Name must be at least 2 characters")
  // Only alphabets allowed: no spaces, numbers, or special characters.
  .matches(/^[A-Za-z]+$/, "Only alphabets are allowed. Spaces, numbers, and special characters are not allowed.");

export const firstNameValidation = nameValidation.required("First name is required");
export const lastNameValidation = nameValidation.required("Last name is required");
